import {createRef, useEffect, useState} from "react";

export const InputTextArea = ({value, error, helperText, label, onChange}) => {
  const inputRef = createRef();
  const [nameclass, setNameclass] = useState("input-text-area");

  const handleFocus = (argFocus) => {
    if (value) {
      if (!nameclass.includes("focus")) {
        setNameclass(nameclass.concat(" focus"));
      }
    } else {
      if (argFocus) {
        if (!nameclass.includes("focus")) {
          setNameclass(nameclass.concat(" focus"));
        }
      } else {
        if (nameclass.includes("focus")) {
          setNameclass(nameclass.replace(" focus", ""));
        }
      }
    }
  }

  if (error) {
    if (!nameclass.includes("error")) {
      setNameclass(nameclass.concat(" error"));
    }
  } else {
    if (nameclass.includes("error")) {
      setNameclass(nameclass.replace(" error", ""));
    }
  }

  useEffect(() => {
    handleFocus();
  },[value]);


  return (
    <div
      className={nameclass}
      onFocus={() => {
        handleFocus(true)
      }}
      onBlur={() => {
        handleFocus(false)
      }}>

      <label className="label" onClick={() => inputRef.current.focus()}>{label}</label>
      <textarea placeholder="Digite aqui..." rows={10} cols={100} ref={inputRef} value={value} onChange={onChange}/>
      {error && <span className="helper">{helperText}</span>}
    </div>
  );
}